import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
export const ContactSection = () => {
  return <section id="contact" className="bg-gradient-to-b from-slate-900 to-slate-900/95 text-white py-12 px-4" data-id="element-13">
      <div className="max-w-5xl mx-auto" data-id="element-14">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8" data-id="element-15">
          <div className="flex items-center gap-3" data-id="element-16">
            <Mail className="h-6 w-6 text-indigo-400" data-id="element-17" />
            <div data-id="element-18">
              <h3 className="font-semibold mb-1" data-id="element-19">Email</h3>
              <a href="mailto:info@TechAIgent.com" className="text-slate-300 hover:text-white transition" data-id="element-20">
                info@TechAIgent.com
              </a>
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-21">
            <Phone className="h-6 w-6 text-indigo-400" data-id="element-22" />
            <div data-id="element-23">
              <h3 className="font-semibold mb-1" data-id="element-24">Phone</h3>
              <a href="tel:+447930381528" className="text-slate-300 hover:text-white transition" data-id="element-25">
                +44 7930 381528
              </a>
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-26">
            <MapPin className="h-6 w-6 text-indigo-400" data-id="element-27" />
            <div data-id="element-28">
              <h3 className="font-semibold mb-1" data-id="element-29">Address</h3>
              <p className="text-slate-300" data-id="element-30">TBC</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};